import { useMemo, useState } from "react";
import { Building2, CircleDollarSign, Home, Share2 } from "lucide-react";

const CompanyIntro = ({ onSelectLabel }) => {
  const [activeLabel, setActiveLabel] = useState("facility");

  const labels = useMemo(
    () => [
      { key: "facility", title: "Facility", icon: Home },
      { key: "franchise", title: "Franchise", icon: Building2 },
      { key: "investment", title: "Investment", icon: CircleDollarSign },
      { key: "external", title: "External", icon: Share2 },
    ],
    [],
  );

  return (
    <div className="company__intro space-y-4">
      <div>
        <h1 className="font-display text-2xl font-semibold mt-4">
          Company Catalogue
        </h1>
        <p className="text-xs text-muted-foreground mt-1 max-w-2xl">
          Create, group and manage the companies, franchises and investments in
          your portfolio.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr] gap-4 items-stretch">
        <div className="flex gap-2 flex-wrap">
          {labels.map(({ key, title, icon: Icon }) => (
            <button
              key={key}
              type="button"
              onClick={() => {
                setActiveLabel(key);
                if (typeof onSelectLabel === "function") onSelectLabel(key);
              }}
              className={`w-[5.25rem] h-[5.25rem] rounded-xl flex flex-col items-center justify-center gap-1.5 transition company__introTile ${
                activeLabel === key
                  ? "bg-primary text-primary-foreground ring-2 ring-primary/40"
                  : "bg-primary text-primary-foreground hover:opacity-90"
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="font-display font-semibold text-xs">
                {title}
              </span>
            </button>
          ))}
        </div>

        <div className="rounded-xl bg-primary text-primary-foreground p-4 company__introPortfolio">
          <h2 className="font-display text-sm font-semibold">
            Company Portfolio
          </h2>
          <p className="text-[11px] opacity-90 mt-1 leading-relaxed">
            Here you can create, group and manage the companies, franchises and
            investments in your portfolio.
          </p>
          <ul className="mt-1.5 space-y-0.5 text-[11px] opacity-90">
            <li>
              • Organise entities into facilities, franchises and investments
            </li>
            <li>• Track climate accounts and reporting status</li>
            <li>• Share access with collaborators and partners</li>
            <li>• Maintain portfolio-level transparency and readiness</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CompanyIntro;
